import { useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { ProviderStatus, UserRole } from '../../enums/shared.enums';
import { Box, Card, CardContent, LinearProgress, Modal, Typography } from '@mui/material';
import { useMutation, useQuery, skipToken } from "@apollo/client/react";
import { GENERATE_STRIPE_ONBOARDING_LINK } from '../../graphql/resolvers/mutations';
import useLocales from '../../hooks/useLocales';
import { GET_STRIPE_ONBOARDING_STATUS } from '../../graphql/resolvers/queries';

const StripeRedirectModal = () => {
    const [open, setOpen] = useState<boolean>(false);
    const { user } = useAuth();
    const { translate } = useLocales();

    const [generateStripeOnboardingLink] = useMutation(GENERATE_STRIPE_ONBOARDING_LINK, {
        variables: {
            providerUserId: user?.userId,
        },
        onCompleted: (data) => {
            window.location.href = data.generateStripeOnboardingLink;
        },
    });

    const { data: onboardingData } = useQuery(GET_STRIPE_ONBOARDING_STATUS, (// Only check for providers who are not leads
            !user?.roles.includes(UserRole.PROVIDER) &&
            user?.providerProfile?.status !== ProviderStatus.LEAD) ? skipToken : { variables: {
            providerUserId: user?.userId,
        } });

    useEffect(() => {
        if (onboardingData) {
            const isOnboardingCompleted = onboardingData.stripeOnboardingStatus?.completed;

            if (!isOnboardingCompleted && user?.providerProfile?.status !== ProviderStatus.LEAD) {
                setOpen(true);
                void generateStripeOnboardingLink();
            } else {
                setOpen(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onboardingData]);

    return (
        <Modal open={open}>
            <Card
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 450,
                }}
            >
                <CardContent
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}
                >
                    <Typography variant="h6" sx={{ textAlign: 'center' }}>
                        {translate('components.user.provider.stripeRedirectModal.title')}
                    </Typography>
                    <Typography>
                        {translate('components.user.provider.stripeRedirectModal.description')}
                    </Typography>
                    <Typography variant="body2">
                        {translate('components.user.provider.stripeRedirectModal.redirectMessage')}
                    </Typography>
                    <Box sx={{ width: '100%', my: 2 }}>
                        <LinearProgress />
                    </Box>
                </CardContent>
            </Card>
        </Modal>
    );
};

export default StripeRedirectModal;
